import * as angular from "angular";
import { Field } from "../../models/field.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { FieldDataProvider } from "../../data-provider/field.dp";

let FieldsDirectoryComponent = {
    selector: "vcFieldsDirectory",
    templateUrl: "/angular/components/field/fields-directory.component.html",
    bindings: {},
    controller: class FieldsDirectoryController {
        public loading: boolean = false;
        public timeoutCode: any;
        public fields: Field[];
        private $scope: any;
        private saving: boolean = false;
        private __env: any;
        private toast: ToastUtils;
        private dialog: DialogUtils;
        private dataProvider: FieldDataProvider;

        constructor(
            $scope: any,
            __env: any,
            $timeout: any,
            __app_type: string,
            FieldDataProvider: FieldDataProvider,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils
        ) {
            this.$scope = $scope;
            this.__env = __env;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;
            this.dataProvider = FieldDataProvider;
        }

        $onInit() {
            this.dataProvider.getFieldsDirectory().then((fields) => {
                this.fields = fields;
                this.loading = false;
            });
        }

        confirm(): void {
            this.saving = true;
            this.dataProvider
                .updateMultiple(this.fields)
                .then((fields: any) => {
                    this.saving = false;
                    this.dialog.hide();
                });
        }

        cancel(): void {
            this.dialog.hide();
        }
    },
};

angular
    .module("field")
    .component(FieldsDirectoryComponent.selector, FieldsDirectoryComponent);
